/**
 * PATCH traffic link (Voluum / Binom / Tres Commas) for SMSWiser campaigns in a
 * country. The backend accepts TRES_COMMAS only where Tres Commas is configured.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TrackerEnum } from '@trafficpulse/shared';

import api from '@/services/api';

import { smswiserKeys } from './useSMSWiser';

export type PatchTrafficProvider = TrackerEnum;

export interface PatchSmswiserCampaignTrafficBody {
  wiserIds: number[];
  trafficProvider: PatchTrafficProvider;
  trafficCampaignId: string | null;
}

export function usePatchSmswiserCampaignTraffic(countryKey: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: PatchSmswiserCampaignTrafficBody) => {
      await api.patch(`/smswiser/campaigns/${countryKey}/traffic`, body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: smswiserKeys.country(countryKey) });
    },
  });
}
